// extracted by mini-css-extract-plugin
export default {"search_suggestions_result_wrapper":"SearchSuggestionsResult_search_suggestions_result_wrapper__haZff","section_name":"SearchSuggestionsResult_section_name__XvtEB"};